import React from 'react'

import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import PaneBody from 'components/Common/Pane/PaneBody'

import {
  LeaderStyledImage,
  LeaderWrapper,
  LeadersWrapper,
} from './style'

import ClickableLink from 'components/Common/Clickable/ClickableLink'
import leadershipTeamMembers from './leadershipTeamMembers'
import BodyText from 'LuxKit/Typography/BodyText'
import styled from 'styled-components'
import { rem } from 'polished'
import Heading from 'LuxKit/Typography/Heading'

const SpacedTitle = styled(BodyText)`
  margin-top: ${rem(8)};
`

function LeadershipTeam() {
  return <Pane>
    <PaneBody size="xl-y md">
      <LayoutContainer>
        <Heading variant="heading3" align="center" as="h2">
          Leadership Team
        </Heading>
        <BodyText variant="large" as="p" align="center">
          Our leaders inspire our team to live according to our company values, which include impressing our customers and clients with a truly exceptional experience, innovation, experimenting and learning, being accountable and being positive and fun.
        </BodyText>
        <LeadersWrapper>

          {leadershipTeamMembers.map(teamMember =>
            <LeaderWrapper key={teamMember.name}>
              <ClickableLink href={teamMember.url} target="_blank">
                {teamMember.image && <LeaderStyledImage highRes alt={teamMember.name} id={teamMember.image} width={124} height={124} />}
                <Heading variant="heading5">{teamMember.name}</Heading>
                <SpacedTitle variant="medium">{teamMember.title}</SpacedTitle>
              </ClickableLink>
            </LeaderWrapper>,
          )}
        </LeadersWrapper>
      </LayoutContainer>
    </PaneBody>
  </Pane>
}

export default LeadershipTeam
